<script lang="ts" setup>
import { ElCol, ElRow } from "element-plus";
import { useI18n } from "vue-i18n";

export interface Props {
  label: string;
  content?: string;
  contentType?: string;
}

const { t } = useI18n();

withDefaults(defineProps<Props>(), {
  content: "",
  contentType: "",
});
</script>

<template>
  <el-row class="read-only-field">
    <el-col :span="7">{{ label }}</el-col>
    <el-col
      :span="17"
      class="content break-word"
    >
      <slot />
      <strong :class="contentType">
        {{ content ?? t("emptyValue") }}
      </strong>
    </el-col>
  </el-row>
</template>

<style lang="css" scoped>
.read-only-field {
  padding: 3px 0 10px;
  font-size: 0.875rem;
}

.content {
  line-height: 23px;
}

.warning {
  color: var(--so-color-warning);
}

.danger {
  color: var(--so-color-error);
}
</style>
